import Spinner from "../Spinner";
import { Context } from "./style";

export default function Button({
  title = "",
  click = () => null,
  width,
  type,
  loading = false,
  id,
}: ButtonProps) {
  return (
    <Context
      id={id}
      onClick={() => click()}
      width={width}
      type={type ?? "button"}
      disabled={loading}
      loading={loading}
    >
      {loading && (
        <div style={{ marginRight: 12 }}>
          <Spinner />
        </div>
      )}
      {title?.toUpperCase()}
    </Context>
  );
}
